/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Im_GoodInputs */

const en_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm Good`)
};

const es_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estoy bien`)
};

const fr_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça me va`)
};

const de_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles gut`)
};

const ja_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今は結構です`)
};

const zh_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我先看看`)
};

const ar_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنا بخير هكذا`)
};

const id_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah Cukup`)
};

const it_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Va bene così`)
};

const ru_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всё в порядке`)
};

const pt_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estou bem assim`)
};

const ko_im_good = /** @type {(inputs: Im_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`괜찮습니다`)
};

/**
* | output |
* | --- |
* | "I'm Good" |
*
* @param {Im_GoodInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const im_good = /** @type {((inputs?: Im_GoodInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Im_GoodInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_im_good(inputs)
	if (locale === "es") return es_im_good(inputs)
	if (locale === "fr") return fr_im_good(inputs)
	if (locale === "de") return de_im_good(inputs)
	if (locale === "ja") return ja_im_good(inputs)
	if (locale === "zh") return zh_im_good(inputs)
	if (locale === "ar") return ar_im_good(inputs)
	if (locale === "id") return id_im_good(inputs)
	if (locale === "it") return it_im_good(inputs)
	if (locale === "ru") return ru_im_good(inputs)
	if (locale === "pt") return pt_im_good(inputs)
	return ko_im_good(inputs)
});